import {
  ORDER_TYPE_CLICK_AND_COLLECT,
  ORDER_TYPE_CLICK_AND_COLLECT_LABEL,
  ORDER_TYPE_CLICK_AND_SEAT_LABEL,
  ORDER_TYPE_DELIVERY,
  ORDER_TYPE_DELIVERY_LABEL,
  ORDER_TYPE_CLICK_AND_SEAT,
} from "../constants";
export const choiceRailOptionsByType = (isMobile) => ({
  [ORDER_TYPE_DELIVERY]: {
    id: ORDER_TYPE_DELIVERY,
    labelOpen: ORDER_TYPE_DELIVERY_LABEL,
    imageName: ORDER_TYPE_DELIVERY,
  },
  [ORDER_TYPE_CLICK_AND_COLLECT]: {
    id: ORDER_TYPE_CLICK_AND_COLLECT,
    labelOpen: ORDER_TYPE_CLICK_AND_COLLECT_LABEL,
    imageName: ORDER_TYPE_CLICK_AND_COLLECT,
  },
  default: {
    id: ORDER_TYPE_CLICK_AND_SEAT,
    labelOpen: ORDER_TYPE_CLICK_AND_SEAT_LABEL,
    imageName: ORDER_TYPE_CLICK_AND_SEAT,
  },
});
export const STATUS = {
  CLOSED: "closed",
  OPEN: "open",
};
